// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3OYB7","footer":"ModalCreateQualiphyProcedure_footer__34gE-","additionData":"ModalCreateQualiphyProcedure_additionData__2kJZ8"};